import { useState } from "react";
import { toast } from "react-toastify";
import { UploadFileTypes } from "../../constants";
import { useNews, useUpload } from "../../hooks";
import { Button, SubmitButton } from "../buttons/Buttons";
import FormWrapper from "../forms/Form";
import ModalWrapper from "./Modal";
import styles from "./Modal.module.css";

function NewNewsModal({ isVisible, handleClose, onNewsAdd }) {
  const [formData, setFormData] = useState({
    title: "",
    content: "",
    photo: "",
  });
  const [newImage, setNewImage] = useState(null);

  const { addNewNews } = useNews();
  const { uploadFile } = useUpload();

  const handleInputChange = (e, useTextCase) => {
    const { name, value } = e.target;
    let newValue = value;
    if (useTextCase === "capitalize") newValue = value.charAt(0).toUpperCase() + value.slice(1);

    setFormData((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const validateData = (data) => {
    if (!data.title || data.title === "") {
      toast.error("Please enter news title");
      return false;
    }

    if (!data.content || data.content === "") {
      toast.error("Please enter news content");
      return false;
    }

    if (!data.photo || data.photo === "") {
      toast.error("Please upload an image");
      return false;
    }

    return true;
  };

  const handleImageAdd = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setNewImage(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!newImage) return toast.error("Please upload an image");

    const { data, error: uploadError } = await uploadFile(newImage, UploadFileTypes.IMAGES);
    if (uploadError) return toast.error(uploadError);

    const dataToUpload = {
      ...formData,
      photo: data.file_id,
    };

    const isValidData = validateData(dataToUpload);
    if (!isValidData) return;

    const { error, success } = await addNewNews(dataToUpload);
    if (error) return toast.error(error);
    toast.success(success);
    onNewsAdd();
  };

  return (
    <>
      <ModalWrapper isVisible={isVisible} onClose={handleClose} name="add-news-modal" fit>
        <FormWrapper id="add-news-form" title={"Add News"} onSubmit={handleSubmit}>
          <div className={styles.news_grid}>
            <div className={`card ${styles.article_photo}`}>
              {newImage ? (
                <>
                  <img src={URL.createObjectURL(newImage)} alt="article" className={styles.uploaded_image} />
                  <Button
                    onClick={() => setNewImage(null)}
                    icon="ic:outline-delete"
                    iconPosition="start"
                    className="delete_image_button"
                  />
                </>
              ) : (
                <>
                  <label htmlFor="article-image" className={styles.upload_button}>
                    Upload Photo
                  </label>
                  <input
                    id="article-image"
                    name="article-image"
                    type="file"
                    accept="image/jpeg, image/png"
                    onChange={handleImageAdd}
                    hidden
                  />
                </>
              )}
            </div>
            <input
              className={`input ${styles.article_title}`}
              name="title"
              placeholder="Enter news title"
              required
              value={formData.title}
              onChange={(e) => handleInputChange(e, "capitalize")}
              maxLength={150}
            />
            <textarea
              className={`textarea ${styles.article_content}`}
              name="content"
              onChange={handleInputChange}
              placeholder="Enter text"
              required
              value={formData.content}
              maxLength={600}
            ></textarea>
            <span className={styles.char_count}>{formData.content?.length ?? 0}/600</span>
          </div>
          <div className="row end">
            <Button className="ghost_gray" onClick={handleClose}>
              Cancel
            </Button>
            <SubmitButton className="cta">Publish</SubmitButton>
          </div>
        </FormWrapper>
      </ModalWrapper>
    </>
  );
}

export default NewNewsModal;
